import React from "react";
import { Paper, Stack, Typography, Divider, CircularProgress } from "@mui/material";
import CandidateGroupCard from "./CandidateGroupCard";

export default function CandidateGroupsPanel({
  selectedCampusId,
  selectedCampusLabel,
  candidateGroups,
  candidateGroupsWithCoverage,
  candidatesLoading,
  candidatesError,
  allocatedKeysByJourneyType,
  busesByJourneyType,
  onAssignMissing,
  onAssignSelected,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
      <Stack spacing={1}>
        <Stack spacing={0.5}>
          <Typography fontWeight={800}>
            Travellers {selectedCampusId ? `• ${selectedCampusLabel}` : ""}
          </Typography>

          {selectedCampusId && (
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              {candidateGroups.length} group
              {candidateGroups.length === 1 ? "" : "s"}
            </Typography>
          )}
        </Stack>

        <Divider />

        {!selectedCampusId ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Select a campus to see suggested groups.
          </Typography>
        ) : candidatesLoading ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={18} />
            <Typography variant="body2">Loading…</Typography>
          </Stack>
        ) : candidatesError ? (
          <Typography variant="body2" color="error">
            {String(candidatesError?.message || candidatesError)}
          </Typography>
        ) : candidateGroups.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            No candidate groups for this campus/date.
          </Typography>
        ) : (
          <Stack spacing={2}>
            {candidateGroupsWithCoverage.map((group) => (
              <CandidateGroupCard
                key={group.groupKey}
                group={group}
                personCoverage={group.personCoverage}
                allocatedKeys={allocatedKeysByJourneyType.get(group._journeyType) || new Set()}
                eligibleBuses={busesByJourneyType.get(group._journeyType) || []}
                // Withheld, not wrapped, when the caller has no handler to give:
                // the card hides its assign controls on their absence.
                onAssignMissing={
                  onAssignMissing ? (busId) => onAssignMissing({ busId, group }) : undefined
                }
                onAssignSelected={
                  onAssignSelected
                    ? (busId, selectedPeople) => onAssignSelected({ busId, group, selectedPeople })
                    : undefined
                }
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}